import card1 from "../images/logo-chrome.svg";
import card2 from "../images/logo-firefox.svg";
import card3 from "../images/logo-opera.svg";
import shapes from "../images/bg-dots.svg";





function Extension() {
    return (
        <div className="extension">
            <div className="features">
                <h4>  Download the extension</h4>
                <p>  We’ve got more browsers in the pipeline. Please do let us know if you’ve got a favourite you’d like us to prioritize.</p>
            </div>
            <div className="cards-container">
                <div className="card card-1">
                    <img src={card1} alt="card-1" />
                    <h3 className="card-title">Add to Chrome</h3>
                    <p className="hero-para">Minimum version 62</p>
                    <img src={shapes} alt="shapes" className="shapes" />
                    <button className="chrome cc">
                    Add & Install Extension
                    </button>

                </div>
                <div className="card card-2">
                    <img src={card2} alt="card-2" />
                    <h3 className="card-title">  Add to Firefox</h3>
                    <p className="hero-para">Minimum version 55</p>
                    <img src={shapes} alt="shapes" className="shapes" />
                    <button className="chrome cc">
                    Add & Install Extension
                    </button>

                </div>
                <div className="card card-3">
                    <img src={card3} alt="card-3" />
                    <h3 className="card-title">  Add to Opera</h3>
                    <p className="hero-para">Minimum version 46</p>
                    <img src={shapes} alt="shapes" className="shapes" />
                    <button className="chrome cc">
                    Add & Install Extension
                    </button>

                </div>
            </div>
        </div>
    )

}
export default Extension;